import styled from 'styled-components'
import { colors, fonts } from 'shared/lib'
import { t } from 'localization'

const TP = 'shared.components.Raffles.RaffleEmptyState'

export const RaffleEmptyState = () => {
  return (
    <Container data-qa="raffle-empty-state">
      <Heading>{t(`${TP}.noUpcoming`, 'No upcoming raffles')}</Heading>
      <Subtext>
        {t(`${TP}.signUpNotify`, 'Sign up to be notified when new raffles open.')}
      </Subtext>
    </Container>
  )
}

const Container = styled.div`
  padding: 40px 0;
`

const Heading = styled.h2`
  ${fonts.SUBTITLE_1}
  text-transform: uppercase;
  margin: 0;
`

const Subtext = styled.p`
  ${fonts.SUBTITLE_3}
  color: ${colors.FC2_GREY};
  margin-bottom: 24px;
`
